<script>
    import R, {LOADER} from "../lib/requests";
    import Notifier from "../stores/notifier";
    import {setFocusTo} from "../lib/lib";
    import Modal from "../components/modal/Modal.svelte";
    import ComponentLoader from "../components/ComponentLoader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";

    export let printItems;
    export let closeCallback;

    let title = 'Εξαγωγή';
    let client = null;
    let order = null;
    let pdfFilename = null;
    let fileList = null;
    let loading = false;
    let exportError = false;

    const exportSamples = () => {

        const onSuccess = result => {
            client = result.client;
            order = result.order;
            pdfFilename = result.filename;
            // window.open(`/documents/${result.filename}?ver=${ Math.random() }`, "_blank");
            // close();
        };

        const onFailure = err => {
            exportError = true;
        };

        R.handle(R.order.exportSamples, {samples: printItems.samples}, onSuccess, onFailure, LOADER.POPUP);
    };

    const exportOrder = () => {

        const onSuccess = result => {
            fileList = result.file_list;
            loading = false;
        };

        const onFailure = err => {
            loading = false;
            exportError = true;
        };

        loading = true;
        R.handle(R.order.exportOrder, printItems.order_id, onSuccess, onFailure, LOADER.NONE);
    }

    const onSend = () => {
        if (!client.email) {
            Notifier.showError("Δεν υπάρχει email για αποστολή!");
            setFocusTo("sendEmail");
        }
    }


    const close = (param) => {
        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    // const toggleClientVisibility = ({detail}) => {
    //     console.log("toggleClientVisibility", detail);
    //     if (detail.checked) {
    //         isOnCloud = 1;
    //         setClientVisibility();
    //     }
    // }
    //
    // const setClientVisibility = () => {
    //     const onSuccess = result => {
    //     };
    //
    //     const onFailure = err => {
    //     };
    //
    //     R.handle(R.sample.setClientVisibility, {sample_id:printItems.samples[0], is_visible_to_client: isOnCloud}, onSuccess, onFailure, LOADER.NONE);
    // }

    if (printItems.object === 'samples') {
        if (printItems.samples.length == 1) {
            title = "Εκτύπωση δείγματος";
        } else {
            title = "Εκτύπωση δειγμάτων";
        }
        exportSamples();
    } else {
        title = "Εξαγωγή εντολής σε PDF";
        exportOrder();
    }
</script>

<Modal title="{ title }" modalXl="{ printItems.object === 'samples' }" on:close="{ close }">
    <div slot="body">
        {#if loading}
            <div class="py-4">
                <ComponentLoader size="50" loading/>
                <p class="text-center mt-3">Δημιουργία Pdf αρχείων</p>
            </div>
        {/if}
        {#if exportError}
            <div class="py-4">
                <div class="text-gray-1">
                    <AppIcon icon="exclamation-triangle-solid" size="50"/>
                </div>
                <p class="text-center mt-3">Παρουσιάστηκε κάποιο σφάλμα κατά την δημιουργία των αρχείων!</p>
            </div>
        {/if}
        {#if pdfFilename}
            <div class="row">
                <div class="col-xl-2 col-lg-3">
                    {#if client}
                        <div class="row">
                            <div class="col-lg-12">
                                <h5 class="mb-3">{ client.company }</h5>
                            </div>
                            <!--                            <div class="col-lg-12 col-md-8 mb-3">-->
                            <!--                                <input type="email" class="form-control" id="sendEmail" bind:value="{ client.email }"-->
                            <!--                                       placeholder="email αποστολής">-->
                            <!--                            </div>-->
                            <!--                            <div class="col-lg-12 col-md-4 mb-3">-->
                            <!--                                <button class="btn btn-primary btn-block" on:click={ onSend }>-->
                            <!--                                    ΑΠΟΣΤΟΛΗ-->
                            <!--                                </button>-->
                            <!--                            </div>-->
                        </div>
                    {/if}
                    <p>
                        Link αρχείου:<br>
                        <a href="/documents/{ pdfFilename }" target="_blank">{ pdfFilename }</a>
                    </p>
                </div>
                <div class="col-xl-10 col-lg-9">
                    <object data="/documents/{ pdfFilename }?ver={ Math.random() }" type="application/pdf"
                            class="pdf-container"></object>
                </div>
            </div>
        {/if}
        {#if fileList}
            <p class="mb-1">
                Links αρχείων:
            </p>
            {#each fileList as file}
                <p class="mb-1">
                    <a href="/documents/{ file.filename }" target="_blank">
                        { file.title } <span class="text-gray">({ file.filename })</span>
                    </a>
                </p>
            {/each}
        {/if}
    </div>
</Modal>

<style>
    .pdf-container {
        width: 100%;
        height: 1200px;
    }

    @media (max-width: 576px) {
        .pdf-container {
            height: calc(100vh - 255px);
        }
    }

    @media (min-width: 577px) and (max-width: 767px) {
        .pdf-container {
            height: calc(100vh - 255px);
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .pdf-container {
            height: calc(100vh - 205px);
        }
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .pdf-container {
            height: calc(100vh - 105px);
        }
    }

    @media (min-width: 1200px) {
        .pdf-container {
            height: calc(100vh - 105px);
        }
    }
</style>